
export const breadcrumb = [
    { path: '/', parent: 'Dashboard', label: 'Dashboard' },
    { path: '/formlayout', parent: 'UI Kit', label: 'Form Layout' },
    { path: '/input', parent: 'UI Kit', label: 'Input' },
    { path: '/floatlabel', parent: 'UI Kit', label: 'Float Label' },
    { path: '/invalidstate', parent: 'UI Kit', label: 'Invalid State' },
    { path: '/button', parent: 'UI Kit', label: 'Button' },
    { path: '/table', parent: 'UI Kit', label: 'Table' },
    { path: '/list', parent: 'UI Kit', label: 'List' },
    { path: '/tree', parent: 'UI Kit', label: 'Tree' },
    { path: '/panel', parent: 'UI Kit', label: 'Panel' },
    { path: '/overlay', parent: 'UI Kit', label: 'Overlay' },
    { path: '/media', parent: 'UI Kit', label: 'Media' },
    { path: '/menu', parent: 'UI Kit', label: 'Menu' },
    { path: '/menu/seat', parent: 'UI Kit', label: 'Menu' },
    { path: '/menu/payment', parent: 'UI Kit', label: 'Menu' },
    { path: '/menu/confirmation', parent: 'UI Kit', label: 'Menu' },
    { path: '/messages', parent: 'UI Kit', label: 'Messages' },
    { path: '/file', parent: 'UI Kit', label: 'File' },
    { path: '/chart', parent: 'UI Kit', label: 'Charts' },
    { path: '/misc', parent: 'UI Kit', label: 'Misc' },
    { path: '/icons', parent: 'Utilities', label: 'Icons' },
    { path: '/blocks', parent: 'PrimeBlocks', label: 'Blocks' },
    { path: '/crud', parent: 'Utilities', label: 'Crud' },
    { path: '/calendar', parent: 'PrimeBlocks', label: 'Calendar' },
    { path: '/timeline', parent: 'Pages', label: 'Timeline' },
    { path: '/invoice', parent: 'Pages', label: 'Invoice' },
    { path: '/invoice2', parent: 'Pages', label: 'Invoice2' },
    { path: '/help', parent: 'Pages', label: 'Help' },
    { path: '/empty', parent: 'Pages', label: 'Empty Page' },
    { path: '/documentation', parent: 'Pages', label: 'Documentation' },

    { path: '/users', parent: 'Users', label: 'Users' },

    { path: '/requisition', parent: 'Requisition', label: 'Requisition' },
    { path: '/workorder', parent: 'Work Order', label: 'Work Order' },
    { path: '/chalan', parent: 'Chalan', label: 'Chalan' },
    { path: '/product', parent: 'Inventory', label: 'Product' },
    { path: '/others', parent: 'Others', label: 'Shop > UOM > Category > Brand' },

    { path: '/supplier', parent: 'Supplier', label: 'Supplier' },
    { path: '/stock', parent: 'Stock', label: 'Stock' },
    { path: '/sale_manually', parent: 'Sale', label: 'Sale' },
    { path: '/sale', parent: 'Sale', label: 'Sale' },
    { path: '/sale_details', parent: 'Sale', label: 'Invoices' },

    { path: '/return_to_supplier', parent: 'Return', label: 'Return To Supplier' },
    { path: '/return_from_employee', parent: 'Return', label: 'Return From Employee' },

    { path: '/report', parent: 'Report', label: 'Report' },
    { path: '/change_password', parent: 'Settings', label: 'Change password' },
    { path: '/logout', parent: 'Settings', label: 'Logout' },


];
